import React from "react";
import { HeroStory } from "web/react/components/home/stories/hero-story";
import {
    mockHeroDetails,
    mockHeroImageSrcs,
    mockPrimaryDetails,
    mockPrimaryImageSrcs,
} from "web/react/components/home/stories/mock-data";
import { PrimaryStory } from "web/react/components/home/stories/primary-story";
import { ArchiveDeviceDivider } from "web/react/emo/archive-device-divider";
import * as styles from "./stories.css";

export function Stories(): React.ReactElement {
    return (
        <section className={styles.wrapper}>
            <div className={styles.stories}>
                <ArchiveDeviceDivider overlap>
                    <HeroStory
                        editorialDetails={mockHeroDetails}
                        desktopImage={mockHeroImageSrcs.desktop}
                        mobileImage={mockHeroImageSrcs.mobile}
                    />
                    <PrimaryStory
                        editorialDetails={mockPrimaryDetails}
                        desktopImage={mockPrimaryImageSrcs.desktop}
                        mobileImage={mockPrimaryImageSrcs.mobile}
                    />
                </ArchiveDeviceDivider>
            </div>
        </section>
    );
}
